import { render, staticRenderFns } from "./PersonalDetailsZakelijk.vue?vue&type=template&id=2953dcd2"
import script from "./PersonalDetailsZakelijk.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsZakelijk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports